import ImageToCode, { ImageToCodeBlock } from './components/ImageToCode';
import PromptToCode, { PromptToCodeBlock } from './components/PromptToCode';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;

  const { types, labels, blocks, category } = opts;

  if (blocks.imageToCode) {
    ImageToCodeBlock(bm, category, labels.imageToCode, types.imageToCode);
    ImageToCode(dc, labels.imageToCode, types.imageToCode, opts);
  }
  if (blocks.promptToCode) {
    PromptToCodeBlock(bm, category, labels.promptToCode, types.promptToCode);
    PromptToCode(dc, labels.promptToCode, types.promptToCode, opts);
  }
};
